import {Injectable} from '@angular/core';
import {EnvironmentService} from './environment.service';
import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable, throwError} from 'rxjs';
import {catchError, map, mergeMap, shareReplay} from 'rxjs/operators';
import fixArray from '../../../utils/fixArray';
import {ProjectService} from './project.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayImagesService {

  constructor(private _environmentService: EnvironmentService,
              private _projectService: ProjectService,
              private _http: HttpClient) {
  }

  httpCache = new Map<string, Observable<any>>();

  getHolidayPhotos(id: number, type: string = 'accomodations'): Observable<string[]> {
    return forkJoin([
      this._environmentService.getEnvironment(),
      this._projectService.getAgencyApikey(),
    ]).pipe(
      mergeMap(e => {
        const url = `${e[0].searchUrl}/index.php/holiday/${e[1]}/${type}/id/${id}/type/photos`;
        if (!this.httpCache.get(url)) {
          this.httpCache.set(url, this._http.get<any>(url).pipe(shareReplay({bufferSize: 1, refCount: true})));
        }
        return this.httpCache.get(url);
      }),
      map(e => fixArray(e.photos).filter(x => x).map(x => x.percorso)),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
